import { DrawerOptions } from '../../models/kt';

export const defaultDrawerOptions: DrawerOptions = {
   overlay: true,
   baseClass: 'drawer',
   overlayClass: 'drawer-overlay',
   direction: 'end',
}
